import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerConsulta(): void {

  const modules = [
    {
      entry: 'historico-solicitacoes',
      id: 'historico-solicitacoes',
      name: 'stipulator-historico.solic',
      route: APPLICATION_ROUTES.HISTORICO_SOLICITACOES,
      closeable: true,
    }, {
      entry: 'inconsistencia-sib',
      id: 'inconsistencia-sib',
      name: 'stipulator.inconsistencias-sib',
      route: APPLICATION_ROUTES.INCONSISTENCIA_SIB,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'consulta',
    id: 'consulta',
    name: 'stipulator.consultas',
    modules,
    order: 5,
    closeable: true,
  });
}
